// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../public/images/homeNo.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../public/images/home.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../public/images/monday.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../public/images/tuesday.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../public/images/wednesday.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',
    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',
    sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}


*{
  padding: 0;
  margin: 0;
  font-family: Arial, Helvetica, sans-serif;
}

body{
  background: #0b0130;
}

.main{
  max-width: 500px;
  height: 782px;
  margin: 0 auto;
  position: relative;
}
.outputNew{
  border: 1px solid red;
  display: flex;
  flex-direction: column;
}
.outputNew span{
  display: block;
  width: 100%;
}

.output,
.outputWithoutComma{
display: none
}


.alpha{
font-size:18px;
position: absolute;
top: 0;
left: 0;
z-index: 2;
padding: 10px;
opacity: 0;
}

.rescan{
margin: 50px 0;
font-size: 18px;
text-align: center;
position: absolute;
top: 0;
left: 0;
z-index: 2;
padding: 10px;
}

.topDiv{
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
z-index: 9;
background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) 0 0 no-repeat;
background-size: cover;
}

.clickReady{
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 20;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) 0 0 no-repeat;
  background-size: cover;
  cursor: pointer;
}

.monday,
.tuesday,
.wednesday{
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 10;
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) 0 0 no-repeat;
  background-size: cover;
}
.tuesday{
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) 0 0 no-repeat;
  background-size: cover;
}
.wednesday{
  background: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) 0 0 no-repeat;
  background-size: cover;
}



#videoTag{
  /* position: fixed; */
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 11;
  opacity: 1;
  /* z-index: 99;
  opacity: 1;
  border: 5px solid red; */
}
#videoTag video{
  width: 100%;
  height: 100%;
}


.loader1 {
  display:inline-block;
  font-size:0px;
  padding:0px;
  position: absolute;
  top: 400px;
  left: 140px;
  z-index: 21;
}
.loader1 span {
  vertical-align:middle;
  border-radius:100%;
  
  display:inline-block;
  width:30px;
  height:30px;
  margin:3px 2px;
  animation:loader1 0.8s linear infinite alternate;
}
.loader1 span:nth-child(1) {
  animation-delay:-1s;
 background:rgba(255, 255, 255,0.6);
}
.loader1 span:nth-child(2) {
  animation-delay:-0.8s;
 background:rgba(255, 255, 255,0.8);
}
.loader1 span:nth-child(3) {
  animation-delay:-0.26666s;
 background:rgba(255, 255, 255,1);
}
.loader1 span:nth-child(4) {
  animation-delay:-0.8s;
 background:rgba(255, 255, 255,0.8);
 
}
.loader1 span:nth-child(5) {
  animation-delay:-1s;
 background:rgba(255, 255, 255,0.4);
}

@keyframes loader1 {
  from {transform: scale(0, 0);}
  to {transform: scale(1, 1);}
}



#changeVal{
  position: absolute; top: 30px; left: 0; z-index: 21; color: #fff; background: red ; 
}
#test{
  position: absolute; top: 0; left: 0; z-index: 21; color: #fff; background: green; min-height: 20px; min-width: 100px;
}
#averageBrightness{
  position: absolute; top: 60px; left: 0; z-index: 21; color: #fff; background: orange ; min-height: 20px; min-width: 100px;
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,SAAS;EACT;;cAEY;EACZ,mCAAmC;EACnC,kCAAkC;AACpC;;;AAGA;EACE,UAAU;EACV,SAAS;EACT,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,qBAAqB;EACrB,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;;AAEA;AACA;;;AAGA;AACA,cAAc;AACd,kBAAkB;AAClB,MAAM;AACN,OAAO;AACP,UAAU;AACV,aAAa;AACb,UAAU;AACV;;AAEA;AACA,cAAc;AACd,eAAe;AACf,kBAAkB;AAClB,kBAAkB;AAClB,MAAM;AACN,OAAO;AACP,UAAU;AACV,aAAa;AACb;;AAEA;AACA,kBAAkB;AAClB,MAAM;AACN,OAAO;AACP,WAAW;AACX,YAAY;AACZ,UAAU;AACV,iEAA4D;AAC5D,sBAAsB;AACtB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,WAAW;EACX,iEAA0D;EAC1D,sBAAsB;EACtB,eAAe;AACjB;;AAEA;;;EAGE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;EACX,iEAA4D;EAC5D,sBAAsB;AACxB;AACA;EACE,iEAA6D;EAC7D,sBAAsB;AACxB;AACA;EACE,iEAA+D;EAC/D,sBAAsB;AACxB;;;;AAIA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,WAAW;EACX,UAAU;EACV;;0BAEwB;AAC1B;AACA;EACE,WAAW;EACX,YAAY;AACd;;;AAGA;EACE,oBAAoB;EACpB,aAAa;EACb,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,WAAW;AACb;AACA;EACE,qBAAqB;EACrB,kBAAkB;;EAElB,oBAAoB;EACpB,UAAU;EACV,WAAW;EACX,cAAc;EAEd,gDAAgD;AAClD;AACA;EAEE,mBAAmB;CACpB,kCAAkC;AACnC;AACA;EAEE,qBAAqB;CACtB,kCAAkC;AACnC;AACA;EAEE,yBAAyB;CAC1B,gCAAgC;AACjC;AACA;EAEE,qBAAqB;CACtB,kCAAkC;;AAEnC;AACA;EAEE,mBAAmB;CACpB,kCAAkC;AACnC;;AAEA;EACE,MAAM,sBAAsB,CAAC;EAC7B,IAAI,sBAAsB,CAAC;AAC7B;;;;AAQA;EACE,kBAAkB,EAAE,SAAS,EAAE,OAAO,EAAE,WAAW,EAAE,WAAW,EAAE,gBAAgB;AACpF;AACA;EACE,kBAAkB,EAAE,MAAM,EAAE,OAAO,EAAE,WAAW,EAAE,WAAW,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,gBAAgB;AACtH;AACA;EACE,kBAAkB,EAAE,SAAS,EAAE,OAAO,EAAE,WAAW,EAAE,WAAW,EAAE,mBAAmB,EAAE,gBAAgB,EAAE,gBAAgB;AAC3H","sourcesContent":["body {\n  margin: 0;\n  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen',\n    'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue',\n    sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n\n*{\n  padding: 0;\n  margin: 0;\n  font-family: Arial, Helvetica, sans-serif;\n}\n\nbody{\n  background: #0b0130;\n}\n\n.main{\n  max-width: 500px;\n  height: 782px;\n  margin: 0 auto;\n  position: relative;\n}\n.outputNew{\n  border: 1px solid red;\n  display: flex;\n  flex-direction: column;\n}\n.outputNew span{\n  display: block;\n  width: 100%;\n}\n\n.output,\n.outputWithoutComma{\ndisplay: none\n}\n\n\n.alpha{\nfont-size:18px;\nposition: absolute;\ntop: 0;\nleft: 0;\nz-index: 2;\npadding: 10px;\nopacity: 0;\n}\n\n.rescan{\nmargin: 50px 0;\nfont-size: 18px;\ntext-align: center;\nposition: absolute;\ntop: 0;\nleft: 0;\nz-index: 2;\npadding: 10px;\n}\n\n.topDiv{\nposition: absolute;\ntop: 0;\nleft: 0;\nwidth: 100%;\nheight: 100%;\nz-index: 9;\nbackground: url('../public/images/homeNo.png') 0 0 no-repeat;\nbackground-size: cover;\n}\n\n.clickReady{\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 20;\n  background: url('../public/images/home.png') 0 0 no-repeat;\n  background-size: cover;\n  cursor: pointer;\n}\n\n.monday,\n.tuesday,\n.wednesday{\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 10;\n  background: url('../public/images/monday.png') 0 0 no-repeat;\n  background-size: cover;\n}\n.tuesday{\n  background: url('../public/images/tuesday.png') 0 0 no-repeat;\n  background-size: cover;\n}\n.wednesday{\n  background: url('../public/images/wednesday.png') 0 0 no-repeat;\n  background-size: cover;\n}\n\n\n\n#videoTag{\n  /* position: fixed; */\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 11;\n  opacity: 1;\n  /* z-index: 99;\n  opacity: 1;\n  border: 5px solid red; */\n}\n#videoTag video{\n  width: 100%;\n  height: 100%;\n}\n\n\n.loader1 {\n  display:inline-block;\n  font-size:0px;\n  padding:0px;\n  position: absolute;\n  top: 400px;\n  left: 140px;\n  z-index: 21;\n}\n.loader1 span {\n  vertical-align:middle;\n  border-radius:100%;\n  \n  display:inline-block;\n  width:30px;\n  height:30px;\n  margin:3px 2px;\n  -webkit-animation:loader1 0.8s linear infinite alternate;\n  animation:loader1 0.8s linear infinite alternate;\n}\n.loader1 span:nth-child(1) {\n  -webkit-animation-delay:-1s;\n  animation-delay:-1s;\n background:rgba(255, 255, 255,0.6);\n}\n.loader1 span:nth-child(2) {\n  -webkit-animation-delay:-0.8s;\n  animation-delay:-0.8s;\n background:rgba(255, 255, 255,0.8);\n}\n.loader1 span:nth-child(3) {\n  -webkit-animation-delay:-0.26666s;\n  animation-delay:-0.26666s;\n background:rgba(255, 255, 255,1);\n}\n.loader1 span:nth-child(4) {\n  -webkit-animation-delay:-0.8s;\n  animation-delay:-0.8s;\n background:rgba(255, 255, 255,0.8);\n \n}\n.loader1 span:nth-child(5) {\n  -webkit-animation-delay:-1s;\n  animation-delay:-1s;\n background:rgba(255, 255, 255,0.4);\n}\n\n@keyframes loader1 {\n  from {transform: scale(0, 0);}\n  to {transform: scale(1, 1);}\n}\n@-webkit-keyframes loader1 {\n  from {-webkit-transform: scale(0, 0);}\n  to {-webkit-transform: scale(1, 1);}\n}\n\n\n\n#changeVal{\n  position: absolute; top: 30px; left: 0; z-index: 21; color: #fff; background: red ; \n}\n#test{\n  position: absolute; top: 0; left: 0; z-index: 21; color: #fff; background: green; min-height: 20px; min-width: 100px;\n}\n#averageBrightness{\n  position: absolute; top: 60px; left: 0; z-index: 21; color: #fff; background: orange ; min-height: 20px; min-width: 100px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
